import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Plus } from 'lucide-react';

function PlaceholderNode({ data }) {
  return (
    <div
      className="rounded-full border border-dashed border-gray-300 bg-white/60 hover:bg-white hover:border-gray-400 hover:scale-105 transition-all duration-150 cursor-pointer"
      style={{ width: 32, height: 32 }}
      onClick={data.onClick}
    >
      {/* Target handle — hidden visually, used for the dashed edge */}
      <Handle
        type="target"
        position={Position.Left}
        className="!w-0 !h-0 !bg-transparent !border-0 !min-w-0 !min-h-0"
      />

      <div className="flex items-center justify-center w-full h-full">
        <Plus className="w-3.5 h-3.5 text-gray-400" strokeWidth={2.5} />
      </div>
    </div>
  );
}

export default memo(PlaceholderNode);
